<template>
  <el-container class="container" style="padding:0">
    <!-- 主要内容容器 -->
    <el-container style="position:relative;height:100%;background: rgb(240, 242, 245);">
      <div style="width:100%;height:100%;display: flex;flex-direction: column;align-items: center;overflow-y: scroll;">
        <div style="width: 1300px;">
          <el-row v-if="true" :gutter="20" style="margin:20px 0 0 0;">
            <el-col :span="24" style="padding:0;">
              <PreviewCard style="height:172px;"/>
            </el-col>
          </el-row>
          <el-row :gutter="20" style="margin:0;display: flex;flex-direction: row;justify-content:center;">

            <LeftBar style="height:270px;background:white;margin-top: 20px;margin-right:10px;width:160px;position: sticky;top:20px;" :left-items="leftItems" :currentSelectLeftItemKey="currentSelectLeftItemKey" :badgeCount="currentSelectLeftItemKey=='todo'?$store.state.todoCount:0" @selectChange="leftItemselectChange"/>

            <MainList style="width:100%;"/>
            <div style="background:white;display: flex;flex-direction: column;align-items:center;justify-content: flex-start;padding:20px 0;margin-top: 20px;margin-left:10px;height: 230px;position: sticky;top:20px;">
              <div style="margin-bottom: 20px;">操作台</div>
              <div v-for="item in rightItems">
                <el-button plain style="border:none;" @click="item.link ? jumpUrl(item.link) : openAddClueDialog()">{{item.name}}</el-button>
              </div>
            </div>
          </el-row>
        </div>

      </div>
    </el-container>
    <addBusinessDialog v-model="dialogFormVisible" @refresh></addBusinessDialog>

  </el-container>
</template>

<script>

import {
  exportAdvance,
  getUnusualList, getAdvance
} from '../../api/api'
import {getMonthStartDate} from "@/utils/util";
import PreviewCard from "@/component/My/PreviewCard";
import MainList from "@/component/My/MainList"
import LeftBar from "@/component/Bar/leftBar/LeftBar";
import addBusinessDialog from "@/component/Business/dialog/addBusinessDialog";
export default {
  name: "PrePayManage",
  props:["refreshId"],
  components:{
    PreviewCard,
    MainList,
    LeftBar,
    addBusinessDialog
  },
  data(){
    return {
      column_mapper:{
        "advance_name":"预付款名称:like",
        "stat_time":"结算日期:date",
        "client_name": "客户:varchar"
      },

      tableData:{
        //表格列表相关
        detailLoading: false,
        projectList: [],//表格列表所有数据
        showProjectList:[],//显示的数据
        column_mapper: {},//表头所有列的枚举
        showColoums: [],//当前显示的表头列
        sortColumnName: "",//需要排序的列名
        sortColumnOrder: "",//排序的命令
        totalnums: 10,//所有的数据条数
        pageNumber: 1,//当前页
        fixedList: ['project:project_id', 'project:project_name'],
        pagesize: 10,//一页数据的行数（公用）
        pagination:true,
        tableColumnCustomConfig:{//图表某些列定制化显示
          'project:project_id':{
            type:"popover",
            showRule:{
              key:"project:project_remark",
              value:"异常"
            },
            project_id:"",
            closeTime:1,
            openTime:0,
            forceClose:false,
            show:false,
            popoverDatas:[]
          }
        }
      },
      leftItems: [
        {
          id: 0,
          name: "我的待办",
          key: "todo",
        }
      ],
      currentSelectLeftItemKey:"todo",

      rightItems: [
        {
          id: 0,
          name: "新建商机",
          key: "clue"
        },
        {
          id: 1,
          name: "新建合同",
          key: "contract",
          link:"https://www.jiandaoyun.com/dashboard#/app/5f2e1e426fd1df00069b94e4/form/5f2e762a2713ef0006975cdd"
        },
        {
          id: 2,
          name: "新建订单",
          key: "order",
          link: "https://www.jiandaoyun.com/dashboard#/app/5e5322c89daa2f000602931c/form/5ee99b310286ca0006f830ed"
        },
        {
          id: 3,
          name: "新建结算",
          key: "done",
          link: "https://www.jiandaoyun.com/dashboard#/app/5e5322c89daa2f000602931c/form/5ef19943335f8500068ba5e9"
        },
        {
          id: 4,
          name: "修改数据",
          key: "data",
          link: "https://www.jiandaoyun.com/dashboard#/app/5e5322c89daa2f000602931c/form/6224d82b3c33620007db85dc"
        }
      ],

      dialogFormVisible:false,
      filterRequestData:{},
      dialogRequestData:{
        invoice_id:""
      },
      filterContent:{
        queryCond: [],
        sortCond: {
          columnName: "",
          value: ""
        },
      },
      filterArchiveData:{
        start_end_date_dynamic:[],
        queryCond: []
      },

      showTimeArea:true
    }
  },
  async mounted() {
    window.vm4 = this
    this.refresh()
  },

  watch:{
    refreshId(newVal){
      console.log('refreshId change,刷新todoList',newVal)
      this.refresh(false)
    },
  },

  methods:{
    filterContentChange(content){
      console.log('filterContentChange',content)
      Object.assign(this.filterContent,content)
      this.refresh()
      // this.getPerformanceData()
    },

    async exportExcel(){
      let param = {
        division:this.currentSelectLeftItemKey
      }
      console.log('exportFinancial/param',param)
      let loadingInstance = this.$loading.service({fullscreen: true, text: '请等待导出'});
      try {
        let {data} = await exportAdvance(param)
        loadingInstance.close();
        const blob = new Blob([data])
        var date = new Date()
        let Y = date.getFullYear().toString()
        let M = (date.getMonth() + 1).toString().padStart(2, "0")
        let D = date.getDate().toString().padStart(2, "0")
        let H = date.getHours().toString().padStart(2, "0")
        let m = date.getMinutes().toString().padStart(2, "0")
        let s = date.getSeconds().toString().padStart(2, "0")
        let fileName = this.leftItems.find(i=>i.key==this.currentSelectLeftItemKey).name + '-' + Y + M + D + H + m + s + ".xlsx"

        const link = document.createElement('a')
        link.download = fileName // a标签添加属性
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        document.body.appendChild(link)
        link.click() // 执行下载
        URL.revokeObjectURL(link.href) // 释放url
        document.body.removeChild(link) // 释
      } catch (err) {
        loadingInstance.close();

        var issafariBrowser = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
        if (issafariBrowser) {
          this.$message.warning("暂不支持在Safari浏览器中导出，请使用其他浏览器")
        } else {
          this.$message.warning(`导出失败,请尝试使用其他浏览器,错误信息(${err})`)
        }


      }

    },

    async unusualShow(project_id){
      let res = await getUnusualList({project_id: project_id})
      let resData = res.data

      if (resData.hasOwnProperty('respCode')) {
        if (resData.respCode == "000000") {
          this.tableData.tableColumnCustomConfig['project:project_id'].project_id = project_id
          this.tableData.tableColumnCustomConfig['project:project_id'].popoverDatas = resData.respData
        } else {
          this.$message.warning(resData.respMsg)
        }
      } else {
        this.$message.error("数据有误")
      }
    },

    /**
     * 表格某行点击
     * @param e 点击item数据
     */
    rowClick(e) {
      this.dialogRequestData = e
      // console.log('rowClick', e['project:project_name'])
      // this.$store.commit("setProjectId", e["project:project_id"]);
      // this.$store.commit("setProjectInfo", {
      //   projectId: e["project:project_id"],
      //   projectName: e["project:project_name"],
      //   accu: 0
      // })
    },
    sortChange(e) {
      console.log('sortChange',e)

      if (e.order === null) {
        this.filterContent.sortCond.columnName = ""
        this.filterContent.sortCond.value = ""
      } else {
        this.filterContent.sortCond.columnName  = e.prop
        if (e.order === 'ascending') {
          this.filterContent.sortCond.value = 'asc'
        } else {
          this.filterContent.sortCond.value = 'desc'
        }
      }
      this.refresh()
    },

    async currentChange(e) {
      console.log('currentChange',e)
      this.tableData.pageNumber = e;
      this.refresh(false)
    },

    shourtcutSelectChange(key){
      this.contentMap[this.currentSelectLeftItemKey].selectShortcutId = key
      this.refresh()
    },

    leftItemselectChange(key){
      console.log('左侧item切换',key)
      this.currentSelectLeftItemKey = key
      // this.refresh()
    },



    async getData(resetPage=false){
      if(resetPage){
        this.tableData.pageNumber = 1
      }

      this.filterRequestData = {
        division:this.currentSelectLeftItemKey,
        pagiInfo: {
          currentPage: this.tableData.pageNumber,
          pagesize: this.tableData.pagesize
        },
        ...this.filterContent
      }
      let postData = this.filterRequestData
      console.log('postData', postData)
      let res = await getAdvance(postData)
      let resData = res.data
      const {respData: {cols_mapper, data , columns_list,totalnums}} = resData
      // console.log('返回结果', resData,cols_mapper,data,columns_list)
      this.tableData.column_mapper = cols_mapper
      this.tableData.projectList = data
      this.tableData.totalnums =  totalnums
      this.tableData.showColoums = columns_list

      // console.log('this.tableData.showColoums',this.tableData.showColoums )


      this.$nextTick(() => {
        this.tableData.detailLoading = false
      })



    },

    jumpUrl(link){
      window.open(link)
    },

    openAddClueDialog(){
      console.log('openAddClueDialog')
      this.dialogFormVisible = true
    },

    async refresh(resetPage=true){
      this.tableData.detailLoading = true
      await this.getData(resetPage)
    }
  }
}
</script>
<style lang="scss">
.el-row {
  margin-bottom: 40px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  height:200px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.left-item{
  border:none !important;
}
.box-card ul li .text{
  font-size: 12px !important;
}
</style>

